function removeLocks (keys) {
  if (!this.dbClient) return
  return this.dbClient.locks.where('key').anyOf(keys).delete()
}

export default removeLocks